// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2Ebhh","row":"styles_row__3N1E7","buttonRow":"styles_buttonRow__3VxaM"};